import styled from 'styled-components'

export const FormContainer = styled.div`
    input {
        border-radius: 3px;
    }

    .Select {
        border-radius: 3px;
    }

    textarea {
        border-radius: 3px;
    }
`

export const ButtonContainer = styled.div``

export const FooterContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
        color: ${({ theme }) => theme['red-500']};
    }
`
